export default {
  hostname: 'https://meal-deal.ru',
  logo: '/images/logo.png',
  site: {
    title: 'Meal Deal'
  }
}